import type { AxiosRequestConfig } from "axios";

import { CONFIG } from "@/config-global";
import { supabase } from "@/lib/supabase";
import axios, { isCancel as axiosIsCancel } from "axios";

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: CONFIG.serverUrl,
  paramsSerializer: {
    serialize: (params) => {
      const searchParams = new URLSearchParams();

      Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((val) => searchParams.append(key, val));
        } else if (value !== undefined && value !== null) {
          searchParams.append(key, value as string);
        }
      });

      return searchParams.toString();
    },
  },
});

// Request interceptor to add Supabase token
axiosInstance.interceptors.request.use(
  async (config) => {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (session?.access_token) {
      config.headers.Authorization = `Bearer ${session.access_token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || "Something went wrong!"
    )
);
export const isCancel = axiosIsCancel;

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  try {
    const [url, config] = Array.isArray(args) ? args : [args];

    const res = await axiosInstance.get(url, { ...config });

    return res.data;
  } catch (error) {
    console.error("Failed to fetch:", error);
    throw error;
  }
};

// ----------------------------------------------------------------------

export const endpoints = {
  chat: "/api/chat",
  file: "/api/file",
  task: "/api/task",
  user: "/api/user",
  notes: "/api/notes",
  client: "/api/client",
  kanban: "/api/kanban",
  contact: "/api/contact",
  project: "/api/project",
  payment: "/api/payment",
  register: "/api/register",
  calendar: "/api/calendar",
  feedback: "/api/feedback",
  milestone: "/api/milestone",
  workspace: "/api/workspace",
  invite: "/api/callback/invite",
  clientNote: "/api/client-note",
  chatMessage: "/api/chat-message",
  fileStorage: "/api/file-storage",
  subscription: "/api/subscription",
  notifications: "/api/notifications",
  projectActivity: "/api/project-activity",
  changeRequestClient: "/api/change-request/client",
  changeRequestMember: "/api/change-request/member",
};
